/**
 * AttributeInformation.DataTypeCode from the Ticketing service, as projected by
 * TicketingController.GetEntityAttributes. Codes not listed describe a related record
 * or an identifier, recognised by their LookupEntity instead.
 */
export const AttributeDataTypeCode = {
  Bit: 0,
  /** A reference to an account or a contact, such as a contact's Company Name. */
  Customer: 1,
  DateTime: 2,
  Decimal: 3,
  Double: 4,
  Int: 5,
  NText: 7,
  Money: 8,
  Picklist: 11,
  State: 12,
  Status: 13,
  Nvarchar: 14,
  MultiSelectPicklist: 16,
};
